import { RunPolicyReceipt } from "types/generated";

import { RunPolicyEvaluation } from "../../types";

export const getPolicyEvaluation = (policies: RunPolicyReceipt[]): RunPolicyEvaluation => {
  const firstTrigger = policies.find((policy) => policy.outcome === "trigger");

  if (firstTrigger) {
    return {
      label: "Trigger",
      badgeVariant: "blue",
      timestamp: firstTrigger.createdAt,
      isImportant: false,
    };
  }

  return {
    label: "Ignore",
    badgeVariant: "gray",
    timestamp: policies[0].createdAt,
    isImportant: false,
  };
};
